class MovieVideoEvent {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event() {

    const modalBtn = document.querySelectorAll(".js-modal-btn")
    const modalTarget = document.querySelector(".js-modal-contents")
    const modalVideo = document.querySelectorAll(".js-modal-video")
    const modalClose = document.querySelector(".js-modal-close")

    modalBtn.forEach((ele, i) => {

      ele.addEventListener("click" ,() => {
        
        modalTarget.classList.add("is-open")

        modalVideo.forEach((video, videoNum) => {
          if(i === videoNum){
            video.classList.add("is-open")
            const videoItem = video.querySelector(".c-modal__video")
            videoItem.play();
          }
        })
      })    
    });

    modalClose.addEventListener("click", () => {
      modalTarget.classList.remove("is-open");

      modalVideo.forEach((el) => {
        el.classList.remove("is-open");
        if (el.getElementsByClassName("c-modal__video").length) {
          const videoItem = el.querySelector(".c-modal__video");
          videoItem.pause();
          videoItem.currentTime = 0; // 再生位置をリセット
        }
      });
    });
  }
}
